import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiRequest } from "src/services/apiClient";
import { Section, SettingRow } from "./SettingsControls";
import { PasswordInput } from "src/components/PasswordInput/PasswordInput";

export function ChangePasswordSection() {
    const { t } = useTranslation();
    const [current, setCurrent]   = useState("");
    const [next, setNext]         = useState("");
    const [confirm, setConfirm]   = useState("");
    const [saving, setSaving]     = useState(false);
    const [error, setError]       = useState<string | null>(null);
    const [saved, setSaved]       = useState(false);

    const handleSave = async () => {
        setError(null);
        if (!current || !next || !confirm) {
            setError(t("settings.pwAllFieldsRequired"));
            return;
        }
        if (next.length < 6) {
            setError(t("settings.pwTooShort"));
            return;
        }
        if (next !== confirm) {
            setError(t("settings.pwMismatch"));
            return;
        }
        setSaving(true);
        try {
            await apiRequest(
                "/settings/change-password",
                { method: "PATCH", body: JSON.stringify({ currentPassword: current, newPassword: next }) },
                { "Content-Type": "application/json" },
            );
            setCurrent(""); setNext(""); setConfirm("");
            setSaved(true);
            setTimeout(() => setSaved(false), 3000);
        } catch (e: any) {
            setError(e?.message ?? t("settings.pwError"));
        } finally {
            setSaving(false);
        }
    };

    return (
        <Section
            title={t("settings.changePassword")}
            actions={
                <button
                    className={`btn-outline${saved ? " btn-outline--saved" : ""}`}
                    onClick={handleSave}
                    disabled={saving}
                >
                    {saved ? t("settings.saved") : saving ? t("settings.saving") : t("settings.saveChanges")}
                </button>
            }
        >
            <SettingRow title={t("settings.currentPassword")}>
                <PasswordInput
                    inputClassName="settings-input"
                    autoComplete="current-password"
                    value={current}
                    onChange={(e) => setCurrent(e.target.value)}
                />
            </SettingRow>
            <SettingRow title={t("settings.newPassword")}>
                <PasswordInput
                    inputClassName="settings-input"
                    autoComplete="new-password"
                    value={next}
                    onChange={(e) => setNext(e.target.value)}
                />
            </SettingRow>
            <SettingRow title={t("settings.confirmPassword")}>
                <PasswordInput
                    inputClassName="settings-input"
                    autoComplete="new-password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                />
            </SettingRow>
            {error && <p className="settings-error">{error}</p>}
        </Section>
    );
}
